import React from 'react';

export const About = () => (
  <div className="wrap">
    <section id="about">
      <div className="sec-head">
        <h2>A studio, not an agency</h2>
        <span className="sec-tag">About HMTechz</span>
      </div>
      <div className="about-grid">
        <div>
          <p>
            <strong>Hakuna Matata Technologies</strong> is a boutique software
            studio. When you work with us, you talk to the people writing the
            code — no account managers, no hand-offs, no offshore mystery team.
          </p>
          <p>
            We keep the roster small on purpose. Fewer projects at a time means
            senior attention on every one of them, honest timelines, and work we
            put our name on.
          </p>
          <p>
            The name is the promise: no worries, just solutions.
          </p>
        </div>
        <ul className="fact-list">
          <li><span>Based in</span><span>NYC &amp; Northern NJ</span></li>
          <li><span>Pricing</span><span>Fixed fee, published</span></li>
          <li><span>Code ownership</span><span>Yours, from day one</span></li>
          <li><span>Revisions</span><span>2 rounds per stage</span></li>
          <li><span>After launch</span><span>30 days free fixes</span></li>
        </ul>
      </div>
    </section>
  </div>
);
